import * as React from "react"
import { cn } from "@lib/cn"
import type { HttpMethod } from "@lib/inertia-types"

const METHOD_COLORS: Record<string, string> = {
  GET: "text-cloverhound-green-600 dark:text-cloverhound-green-400",
  POST: "text-cloverhound-blue-600 dark:text-cloverhound-blue-400",
  PUT: "text-cloverhound-yellow-600 dark:text-cloverhound-yellow-400",
  PATCH: "text-cloverhound-orange-500 dark:text-cloverhound-orange-300",
  DELETE: "text-cloverhound-red-500 dark:text-cloverhound-red-400",
  HEAD: "text-cloverhound-gray-600 dark:text-cloverhound-gray-400",
  OPTIONS: "text-cloverhound-gray-600 dark:text-cloverhound-gray-400",
  ANY: "text-cloverhound-indigo-600 dark:text-cloverhound-indigo-300",
}

const SHORT: Record<string, string> = { DELETE: "DEL", OPTIONS: "OPT", PATCH: "PAT" }

export function MethodBadge({
  method,
  className,
}: {
  method: HttpMethod | string
  className?: string
}) {
  return (
    <span
      className={cn(
        "w-8 shrink-0 text-right font-mono text-[10px] font-bold tracking-tight",
        METHOD_COLORS[method] ?? METHOD_COLORS.GET,
        className,
      )}
    >
      {SHORT[method] ?? method}
    </span>
  )
}
